import I18n from "i18n-js";
import { makeAutoObservable } from "mobx";
import { RDate } from "../../core";
import { OnTimeFulfillmentTime, } from "../../ordering";
import { RArray } from "../../collections";
export class PInFutureFulfillmentTime {
    constructor(params) {
        this.type = "InFuture";
        this.purchaseOrderFulfillmentTime = params.purchaseOrderFulfillmentTime;
        this.label = I18n.t("orders.form.choose_date");
        makeAutoObservable(this);
    }
    get fulfillmentTime() {
        return this.purchaseOrderFulfillmentTime.fulfillmentTime;
    }
    get activeDate() {
        return this.purchaseOrderFulfillmentTime.activeDate;
    }
    get isAvailable() {
        return this.purchaseOrderFulfillmentTime.inFutureOptionAvailabile;
    }
    get isActive() {
        return (this.isAvailable &&
            this.fulfillmentTime !== null &&
            this.fulfillmentTime.type === "OnTime");
    }
    get dates() {
        return this.purchaseOrderFulfillmentTime.availableDates;
    }
    get calendarDisabled() {
        return this.dates.isEmpty;
    }
    get hoursDisabled() {
        return this.hours.isEmpty;
    }
    get dateRange() {
        var _a, _b, _c, _d, _e;
        const { availableDates } = this.purchaseOrderFulfillmentTime;
        return {
            min: (_b = (_a = availableDates.reduce((min, dateAndHours) => {
                const { date } = dateAndHours;
                return min === undefined ? date : date.isBefore(min) ? date : min;
            }, undefined)) === null || _a === void 0 ? void 0 : _a.fullDate) !== null && _b !== void 0 ? _b : undefined,
            max: (_d = (_c = availableDates.reduce((max, dateAndHours) => {
                const { date } = dateAndHours;
                return max === undefined ? date : date.isAfter(max) ? date : max;
            }, undefined)) === null || _c === void 0 ? void 0 : _c.fullDate) !== null && _d !== void 0 ? _d : undefined,
            dates: (_e = availableDates.raw.map((dateAndHours) => {
                const { date } = dateAndHours;
                const isToday = date.isToday;
                const isTomorrow = RDate.now(date.tz).add(1, "day").fullDate === date.fullDate;
                const dayName = isToday
                    ? I18n.t("date.today")
                    : isTomorrow
                        ? I18n.t("date.tomorrow")
                        : I18n.t(`date.day.names.${date.weekday.toLowerCase()}`);
                return {
                    label: `${
                    // Capitalize first letter due to translations missmatch
                    dayName.charAt(0).toUpperCase() + dayName.slice(1)}, ${date.format("DD/MM/YYYY")}`,
                    value: date.fullDate,
                };
            })) !== null && _e !== void 0 ? _e : [],
        };
    }
    get hours() {
        if (this.activeDate === null) {
            return RArray.empty();
        }
        return this.activeDate.hours.map((item) => item.fullHour);
    }
    setDefaultValue() {
        if (this.dates.isEmpty) {
            return;
        }
        this.purchaseOrderFulfillmentTime.fulfillmentTime =
            new OnTimeFulfillmentTime({
                date: this.dates.get(0).hours.get(0),
                label: null,
            });
    }
    setDate(value) {
        const date = RDate.fromString(value, this.purchaseOrderFulfillmentTime.timezone);
        if (!date.isValid) {
            return; // TODO: what if date is not valid?
        }
        const dateWithHours = this.purchaseOrderFulfillmentTime.getDate(date);
        this.purchaseOrderFulfillmentTime.fulfillmentTime =
            new OnTimeFulfillmentTime({
                date: dateWithHours !== null ? dateWithHours.hours.get(0) : date,
                label: null,
            });
    }
    setHour(value) {
        if (this.activeDate === null) {
            return;
        }
        const hour = this.activeDate.hours.findWhere((item) => item.fullHour === value);
        if (hour === null) {
            return;
        }
        this.purchaseOrderFulfillmentTime.fulfillmentTime =
            new OnTimeFulfillmentTime({
                date: hour,
                label: null,
            });
    }
}
